import { defineComponent } from "@vue/composition-api";
import { useApplicantHelpers } from "@Client/@Composables/application-standalone/pages/applicants/useApplicantHelpers";
import { useOtherPropertiesHelpers } from "@Client/@Composables/application-standalone/pages/other-properties/useOtherPropertiesHelpers";
import SummarySectionLayout from "./summary-section-layout.vue";
import { useAddress } from "@Shared/@Composables/generic/useAddress";
export default defineComponent({
  name: "OtherPropertiesSection",
  components: {
    SummarySectionLayout
  },
  props: {
    hasMissingInformation: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const {
      applicantNameFromIndex
    } = useApplicantHelpers();
    const {
      applicantHasOtherProperties
    } = useOtherPropertiesHelpers();
    const otherPropertyFormattedAddress = property => {
      var _property$propertyDe;
      return useAddress((_property$propertyDe = property["property-details"]) == null ? void 0 : _property$propertyDe["address"]).fullAddress.value;
    };
    return {
      applicantNameFromIndex,
      applicantHasOtherProperties,
      otherPropertyFormattedAddress
    };
  }
});